import React from "react";
import { ModalBody, ModalHeader, ModalFooter, ButtonGroup, Button, Modal } from "reactstrap";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { reservationRoomsDataColumns } from "./dataColumns";
import { Spinner } from "react-activity";
import "react-activity/dist/react-activity.css";
const RoomsModal = ({
  isOpen,
  updateProps,
  mergeProps,
  submitRooms,
  deleteRoom,
  reservationRooms,
  isRoomSaving,
  roomModalReservationId,
  hotelsLookup
}) => {
  const roomRows = reservationRooms && reservationRooms.data ? reservationRooms.data : [];
  const hotelRows = hotelsLookup && hotelsLookup.data ? hotelsLookup : { data: [] };

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        updateProps([{ prop: "isRoomModalOpen", value: !isOpen }]);
      }}
      className="modal-lg reservations-modal"
    >
      <ModalHeader
        toggle={() => {
          updateProps([{ prop: "isRoomModalOpen", value: !isOpen }]);
        }}
      >
        <span className="reservations-modal__title">
          Reservation {roomModalReservationId} Rooms
        </span>
      </ModalHeader>
      <ModalBody className="reservations-modal__body">
        <div className="reservations-modal__summary">
          <div className="reservations-modal__summary-item">
            <span className="reservations-modal__summary-label">Reservation</span>
            <span className="reservations-modal__summary-value">
              {roomModalReservationId || "-"}
            </span>
          </div>
          <div className="reservations-modal__summary-item">
            <span className="reservations-modal__summary-label">Rooms</span>
            <span className="reservations-modal__summary-value">{roomRows.length}</span>
          </div>
        </div>

        <div className="reservations-modal__toolbar">
          <ButtonGroup>
          <Button
            color={"faiz1"}
            onClick={() => {
              mergeProps([
                { prop: "reservationRooms.data", value: [{ reservation_id: roomModalReservationId, hotel_id: {}, room_number: "" }] }
              ]);
            }}
          >
            <i className={"fa fa-plus"} /> Add Room
          </Button>
        </ButtonGroup>
        </div>

        <div className="reservations-modal__table-shell">
        <ReactTable
          data={roomRows}
          columns={reservationRoomsDataColumns(updateProps, deleteRoom, hotelRows)}
          className="-highlight -striped reservations-table"
          defaultPageSize={5}
          filterable
        />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            // updateProps([{ prop: "isRoomModalOpen", value: !isOpen }]);
            submitRooms(reservationRooms);
          }}
        >
          {isRoomSaving ? (
            <>
              <Spinner size={10} animating={true} color={"white"} />
              &nbsp;
            </>
          ) : null}
          Save
        </Button>{" "}
        <Button
          color="secondary"
          onClick={() => {
            updateProps([
              { prop: "isRoomModalOpen", value: !isOpen },
              { prop: "roomModalReservationId", value: null },
              { prop: "reservationRooms", value: [] }
            ]);
          }}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default RoomsModal;
